export class LogoutContext {

    /**
     * Message to inform a user about why and how they've been logged out.
     */
    public message: string = '';
}
